// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---fkBNu","marginBottom0":"marginBottom0---yr7L_","marginTop0":"marginTop0---CZOvp"};